<template>
  <div class="complex-wrap">
    <div class="shop" v-for="shop in shops" :key="shop.shopId">
      <div class="shopname">
        {{ shop.shopName }}
      </div>
      <el-select
        :value="form[key][shop.shopId]"
        v-if="options[shop.shopId]"
        @change="(v) => onChange(v, shop.shopId)"
      >
        <el-option
          v-for="op in options[shop.shopId]"
          :key="op.id"
          :value="op.id"
          :label="op.templateName"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { getPostageList } from "@/servers/prod/center/tm.js";
import _ from "lodash";

export default {
  props: ["props", "value", "form", "shops"],
  data() {
    return {
      options: {},
    };
  },
  computed: {
    key() {
      return this.props.name;
    },
    tips() {
      return this.props.tipRule || "";
    },
    hasTips() {
      return this.tips.length;
    },
  },
  methods: {
    onChange(v, shopId) {
      let newVal = _.cloneDeep(this.form[this.key])
      newVal[shopId] = v
      this.$emit('change', newVal)
    },
    async fetchPostageList(shopId) {
      const list = await getPostageList(shopId);
      const first_postage_id = this.form[this.key]['null']
      if (first_postage_id) {
        // 若存在这种，代表是刚下下来的数据，那么运费模板都取这个值
        if (list.map(item => item.id).includes(first_postage_id)) {
          // 刚下下来的模板id在列表中，那么需要给他初始化值，不在就不初始化了
          this.onChange(first_postage_id, shopId)
        }
      } else {
        // 没有first_postage_id 代表第二次编辑了，直接去对应的postage_id即可
        let currId = this.form[this.key][shopId]; // 当前店铺的postage_id
        if (currId && !list.map(item => item.id).includes(currId)) {
            // 当前店铺的postage_id存在却又不在模板列表里，那么需要给他替换新的值
            currId = list[0]?.id || undefined
            this.onChange(currId, shopId)
        }
      }

      
      this.$set(this.options, shopId, list || [])
    },
  },
  watch: {
    shops: {
      immediate: true,
      handler(v) {
        if (!v || !v.length) {
          return;
        }
        v.forEach((element) => {
          this.fetchPostageList(element.shopId);
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  font-size: 12px;
  color: #a5a5a5;
}
.shop {
  display: flex;
  align-items: center;
  font-size: 12px;
  .shopname {
      margin-right: 10px;
  }
}
.shop + .shop {
    margin-top: 15px;
}
</style>